import styled from 'styled-components';

import { Caption, colors, H3, spacing, fontWeights } from 'ui/theme';

import { CardTitle, SkeletonRow } from '../Styles';

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EngagementTitle = styled(CardTitle)`
  margin-bottom: ${spacing.threeQuarter};
`;

export const EngagementCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LeftColumnData = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.quarter};
`;
export const RightColumnData = styled.div`
  display: flex;
  align-items: center;
`;

export const TotalEventsText = styled(H3)`
  font-weight: ${fontWeights.bold};
`;
export const DefaultEventsText = styled(H3)`
  font-weight: ${fontWeights.bold};
  color: ${colors.textDisabled};
`;

export const MedianCompareText = styled(Caption)`
  color: ${colors.textPrimary};
  margin-right: ${spacing.eighth};
`;

export const EngagementSkeletonRow = styled(SkeletonRow)`
  justify-content: space-between;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.quarter};
`;

export const EngagementSkeletonRightText = styled.div`
  display: flex;
`;
